import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Notes from '../common/components/notes';
import { addDomainDetailNotesModal } from '../common/actions/modal-action-creators';

export const DomainDetailsNotesContainer = ( { openNotesModal, domainNotesData } ) => {
    return (
        <Notes
            addNote={openNotesModal}
            notesData={domainNotesData}
            dataAutomationId="domain-details-notes"
        />
    );
};


const MapDispatchToProps = {
    openNotesModal: addDomainDetailNotesModal,
};

DomainDetailsNotesContainer.propTypes = {
    domainNotesData: PropTypes.array,
    openNotesModal: PropTypes.func.isRequired,
};

export default connect( null, MapDispatchToProps )( DomainDetailsNotesContainer );
